<template>
  <div class="modal .collapse.show" tabindex="-1" role="dialog" aria-labelledby="fraudModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="delete-modal-header">
          <h3 class="modal-title">Suspeita de Fraude</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">
              &times;
            </span>
          </button>
        </div>

        <div class="delete-body">
          <div class="body-title">
            Para marcar esta biometria como suspeita de fraude, preencha o motivo abaixo e clique em enviar.
          </div>

          <div class="fraud-row">
            <div class="form-group">
              <label class="fraud-label">Código SAF</label>
              <input class="fraud-field" type="text" :placeholder="safCode" readonly/>
            </div>
          </div>

          <div class="fraud-row">
            <div class="form-group">
              <label class="fraud-label">Motivo</label>
              <textarea class="fraud-field" v-model="description"
                        rows="6" cols="85" id="motivodesc" required>
              </textarea>
            </div>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="button" v-on:click="sendToFraud" data-dismiss="modal" class="btn btn-danger">
            Salvar
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import interceptor from '../../interceptor'
import $ from 'jquery'

export default {
  name: 'Modal',
  props: {
    idn: '',
    cpf: ''
  },
  data: function () {
    return {
      safCode: '',
      description: ''
    }
  },
  computed: function () {},
  mounted() {
    interceptor.request('get', 'api/v1/fraud/safgenerate', {})
      .then(async response => {
        this.safCode = await response.data
      })
    // .catch(function (error) {
    //   console.log(error.response.status)
    //   $('#divAlert').attr('class', 'alert alert-danger')
    //     .append('<p style="font-weight: bold;">Não foi possível efetuar esta ação. Serviço indisponível.</p>')
    //     .show()
    // })
  },
  methods: {
    sendToFraud: function (event) {
      event.preventDefault()
      // this.clear()
      const user = window.localStorage.getItem('usercod')
      const idn = this.idn
      const cpf = this.cpf
      const safCode = this.safCode
      const description = this.description
      const status = 'IN_ANALISIS'
      const suspect = true
      interceptor.request('post', 'api/v1/fraud/fraudsuspect', {user, idn, cpf, safCode, description, suspect, status})
        .then(response => {
          $('#divAlert').attr('class', 'alert alert-success')
            .append('<p style="font-weight: bold;">Biometria marcada como suspeita de Fraude. Código SAF: ' + safCode + '</p>')
            .show()
        })
        .catch(function (error) {
          console.log(error.response.status)
          $('#divAlert').attr('class', 'alert alert-danger')
            .append('<p style="font-weight: bold;">Não foi possível efetuar esta ação. Serviço indisponível.</p>')
            .show()
        })
    }
  }
}
</script>

<style scoped>
.fraud-modal-header {
  background-color: #211858;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}

.fraud-modal-header > h3 {
  font-weight: 600;
  font-size: 1.2rem;
  color: var(--color-e9ecef);
}

.fraud-modal-header > button {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(141deg) brightness(103%) contrast(103%);
}

.fraud-body {
  display: flex;
  flex-direction: column;
  margin: 2rem;
  gap: 1rem;
  justify-content: flex-start;
  align-items: center;
}

.body-title {
  font-weight: 520;
  font-size: 1.4rem;
  letter-spacing: 1.2px;
  text-transform: capitalize;
}

.fraud-row {
  display: block;
  width: 100%;
}

.fraud-field {
  width: 98%;
}

.fraud-label {
  display: block;
  font-size: 1.2rem;
  margin-top: 1rem;
}


.delete-modal-header {
  background-color: #211858;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}

.delete-modal-header > h3 {
  font-weight: 600;
  font-size: 1.2rem;
  color: var(--color-e9ecef);
}

.delete-modal-header > button {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(141deg) brightness(103%) contrast(103%);
}

.delete-body {
  display: flex;
  flex-direction: column;
  margin: 2rem;
  gap: 1rem;
  justify-content: flex-start;
  align-items: center;
}

.body-title {
  font-weight: 520;
  font-size: 2rem;
  letter-spacing: 1px;
  text-transform: capitalize;
}

.delete-row {
  display: block;
  width: 100%;
}

.delete-field {
  width: 98%;
}

.delete-label {
  display: block;
  font-size: 1.2rem;
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// FraudModal.vue?0450e9e2